module.exports = __webpack_public_path__ + "img/dashboard-offer.c7e4ff12.svg";